import { render, staticRenderFns } from "./EditionDetail.vue?vue&type=template&id=4d9f61c4&scoped=true"
import script from "./EditionDetail.vue?vue&type=script&lang=js"
export * from "./EditionDetail.vue?vue&type=script&lang=js"
import style0 from "./EditionDetail.vue?vue&type=style&index=0&id=4d9f61c4&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d9f61c4",
  null
  
)

export default component.exports